/**
 * Hugs Health — scroll-triggered stat count-up.
 * Animates any [data-hugs-count-to] element from 0 to its target value
 * once it scrolls into view. Mirrors the Grüns "60+ / 21 / 6g" reveal.
 */
class HugsStatCounter extends HTMLElement {
  connectedCallback() {
    this.targets = Array.from(this.querySelectorAll('[data-hugs-count-to]'));
    if (!this.targets.length) return;

    this.hasRun = false;
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.hasRun) {
            this.hasRun = true;
            this.animate();
            this.observer.disconnect();
          }
        });
      },
      { threshold: 0.35 }
    );
    this.observer.observe(this);
  }

  animate() {
    const duration = parseInt(this.dataset.duration || '1400', 10);
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.targets.forEach((el, index) => {
      const target = parseFloat(el.dataset.hugsCountTo);
      const prefix = el.dataset.prefix || '';
      const suffix = el.dataset.suffix || '';
      const decimals = parseInt(el.dataset.decimals || '0', 10);

      if (prefersReducedMotion || isNaN(target)) {
        el.textContent = prefix + target + suffix;
        return;
      }

      const start = performance.now();
      const stagger = index * 120;

      const step = (now) => {
        const elapsed = now - start - stagger;
        if (elapsed < 0) {
          requestAnimationFrame(step);
          return;
        }
        const progress = Math.min(elapsed / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3); // ease-out-cubic
        const value = (target * eased).toFixed(decimals);
        el.textContent = prefix + value + suffix;
        if (progress < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    });
  }
}

customElements.define('hugs-stat-counter', HugsStatCounter);
